import { takeLatest, put } from 'redux-saga/effects';

function* openExtensionStore() {
  window.open('https://chrome.google.com/webstore/search/tourconnect?hl=en')
  yield put({ type: 'google_instructions_OpenExtensionsStore_SUCCESS' });
}

function* openGmail() {
  window.open('https://mail.google.com')
  yield put({ type: 'google_instructions_OpenGmail_SUCCESS' });
}
export const googleSagas = [
  takeLatest('google_instructions_OpenGmail', openGmail),
  takeLatest('google_instructions_OpenExtensionsStore', openExtensionStore),
];